import { Box, Typography, CircularProgress, Paper } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { mercadoPagoService } from '../../shared/services/api/mercadoPagoService';
import { feedback } from '../../shared/services';

export const SubscriptionCheckout: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const businessId = searchParams.get('businessId');
  const planSlug = searchParams.get('plan') || 'solo';
  const billingCycle = searchParams.get('cycle') || 'monthly';

  useEffect(() => {
    if (!businessId) {
      feedback('ID do estabelecimento não encontrado.', 'error');
      navigate('/');
      return;
    }

    const createAndRedirect = async () => {
      try {
        const result = await mercadoPagoService.createSubscription({
          businessId: Number(businessId),
          planSlug,
          billingCycle: billingCycle as 'monthly' | 'yearly',
        });

        // Redirect to Mercado Pago checkout
        window.location.href = result.checkoutUrl;
      } catch (error: unknown) {
        const message = error instanceof Error ? error.message : 'Erro ao criar assinatura';
        feedback(message, 'error');
        navigate(`/create-business-trial?plan=${planSlug}`);
      }
    };

    createAndRedirect();
  }, [businessId, planSlug, billingCycle, navigate]);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="background.default"
      padding={3}
    >
      <Paper sx={{ p: 6, maxWidth: 450, textAlign: 'center', borderRadius: 3 }}>
        <CircularProgress size={48} sx={{ mb: 3 }} />
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Redirecionando para o pagamento...
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Você será redirecionado para o Mercado Pago para autorizar sua assinatura.
          Não feche esta página.
        </Typography>
      </Paper>
    </Box>
  );
};
